module.exports = __webpack_public_path__ + "img/aeroland-app-landing-image-04.07f1240b.png";